'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import DealList from 'AdsUI/components/DealList';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';
import I18n from 'I18n';
import UILink from 'UIComponents/link/UILink';
import H2 from 'UIComponents/elements/headings/H2';

class DealListDrop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPanelOpen: false
    };
    this.toggleIsPanelOpen = this.toggleIsPanelOpen.bind(this);
  }

  toggleIsPanelOpen() {
    this.setState({
      isPanelOpen: !this.state.isPanelOpen
    });
  }

  onOpenStart() {
    usageTracker.track('viewedDealList');
  }

  render() {
    const {
      total,
      deals
    } = this.props;

    if (total) {
      return /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(UILink, {
          className: "contacts-drop-link",
          onClick: this.toggleIsPanelOpen,
          children: I18n.formatNumber(total)
        }), this.state.isPanelOpen && /*#__PURE__*/_jsxs(UIModalPanel, {
          onEsc: this.toggleIsPanelOpen,
          width: 500,
          onOpenStart: this.onOpenStart,
          children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
            children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
              onClick: this.toggleIsPanelOpen
            }), /*#__PURE__*/_jsx(H2, {
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "campaigns.deals"
              })
            })]
          }), /*#__PURE__*/_jsx(UIDialogBody, {
            children: /*#__PURE__*/_jsx(DealList, {
              deals: deals,
              total: total
            })
          }), /*#__PURE__*/_jsx(UIDialogFooter, {
            children: /*#__PURE__*/_jsx(UIButton, {
              use: "tertiary-light",
              onClick: this.toggleIsPanelOpen,
              children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: "closeButton"
              })
            })
          })]
        })]
      });
    } else {
      return /*#__PURE__*/_jsx("span", {
        children: I18n.formatNumber(total)
      });
    }
  }

}

DealListDrop.propTypes = {
  deals: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired
};
export default DealListDrop;